import { BaseTCatalogTemplate } from "./BaseTCatalogTemplate";
import { ECatalogFilter } from "./ECatalogFilter";

export default abstract class BaseMCatalogTemplate {
  protected entity: BaseTCatalogTemplate;
  protected readonly _container: HTMLElement;

  protected constructor(container: HTMLElement) {
    this._container = container;
  }

  get container(): HTMLElement {
    return this._container;
  }

  public abstract HasFilter(
    key: number | number[],
    type: ECatalogFilter,
  ): boolean;

  protected hasDifficulty(key: number): boolean {
    return this.entity.difficulties
      ? this.entity.difficulties.includes(key)
      : null;
  }
}
